export default "__VITE_ASSET__D0CTT8wc__"